export default theme => ({
  root: {
    width: 64,
    height: 37,
    padding: 0,
  },
  benchSwitchBase: {
    '&$benchChecked': {
      transform: 'translateX(32px)',
      color: theme.palette.common.white,
      '& + $benchBar': {
        backgroundColor: theme.palette.primary[400],
        opacity: 1,
        border: 'none',
      },
      '& $benchIcon': {
        boxShadow: theme.shadows[1],
        width: 8,
        borderRadius: 100,
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  benchChecked: {},
  benchBar: {
    borderRadius: 100,
    width: 64,
    height: 32,
    marginTop: 5,
    backgroundColor: '#CACDD2',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  benchIcon: {
    width: 24,
    height: 24,
  },
  labelContainer: {
    alignItems: 'start',
    margin: 0,
  },
  label: {
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: 700,
    color: '#484B50',
    letterSpacing: '2px',
  },
});
